import { render, staticRenderFns } from "./SecurityAccessBanner.vue?vue&type=template&id=41dfcf5a&scoped=true&"
import script from "./SecurityAccessBanner.vue?vue&type=script&lang=js&"
export * from "./SecurityAccessBanner.vue?vue&type=script&lang=js&"
import style0 from "./SecurityAccessBanner.vue?vue&type=style&index=0&id=41dfcf5a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41dfcf5a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/skysql-ui-client/skysql-ui-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41dfcf5a')) {
      api.createRecord('41dfcf5a', component.options)
    } else {
      api.reload('41dfcf5a', component.options)
    }
    module.hot.accept("./SecurityAccessBanner.vue?vue&type=template&id=41dfcf5a&scoped=true&", function () {
      api.rerender('41dfcf5a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/service/SecurityAccessBanner.vue"
export default component.exports